import Events from './events';
import Forms from './components/Forms/forms';
import Search from "./components/search";
import Agent from './agent';

const $ = require('jquery');
global.jQuery = $;

import yall from 'yall-js';
import Swiper, {
  Navigation,
  Autoplay,
  Thumbs
} from 'swiper';
import {
  CallPrint
} from "./components/common";

require('@fancyapps/fancybox');

$('.js_fancybox').fancybox({
	buttons: [
    "zoom",    
    "slideShow",    
    "download",    
    "close"
  ]
});

try {
  if (!'IntersectionObserver' in window ||
    !'IntersectionObserverEntry' in window ||
    !'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    let observer = async () => await import('./components/observer');
    observer().then(e => e);
  } else {
    yall({
      observeChanges: true,
      events: {
        load: function(event) {
          if (!event.target.classList.contains("lazy") && event.target.nodeName === "IMG") {
            event.target.classList.add("yall-loaded");
          }
        },
        play: function(event) {
          if (event.target.nodeName === "VIDEO") {
            event.target.nextElementSibling.classList.add("visible");
          }
        }
      }
    });
  }
} catch (e) {
  let observer = async () => await import('./components/observer');
  observer().then(i => i);
}



const events = new Events();
new Forms(events);
new Search(events);

let locations = null;
document.querySelectorAll('.geo_location').forEach(item => item.addEventListener('click', (event) => {
  event.stopPropagation();
  event.preventDefault();
  if (locations === null) {
    let location = async () => await import('./components/locations');
    location().then(f => locations = f.init(events)).then(() => locations.getLocations(item))
  } else {
    locations.getLocations(item);
  }
}));

let addToCart = null;
document.querySelectorAll('.addtocart').forEach(item => {
  if (addToCart === null) {
    let toCart = async () => await import('./components/Basket/addToCart');
    toCart().then(e => addToCart = e.addToCart).then(() => item.addEventListener('click', addToCart, false))
  } else {
    item.addEventListener('click', addToCart, false)
  }
})

let deleteFromBasket = null
document.querySelectorAll('.rbm_js_del_good_cart').forEach(item => {
  if (deleteFromBasket === null) {
    let toCart = async () => await import('./components/Basket/deleteFromBasket');
    toCart().then(e => deleteFromBasket = e.deleteFromBasket).then(() => item.addEventListener('click', deleteFromBasket, false))
  } else {
    item.addEventListener('click', deleteFromBasket, false)
  }
})

if (document.querySelector('.js_add_comment')) {
  const comment = async () => await import("./components/Comments/comment");
  comment().then(f => f.init(events))
}

if (document.querySelector('.rbm_js_filter2_form')) {
  const filter = async () => await import("./components/Filter/filter");
  filter().then(f => f.init(events))
}

if (document.querySelector('.rbm_js_product_count')) {
  const order = async () => await import("./components/Basket/order");
  order().then(f => f.init(events))
}

if (document.querySelector('input[type="number"]')) {
  const number = async () => await import("./components/ui_number");
  number().then(f => f.init('input[type="number"]'))
}

if (document.querySelector('select')) {
  const select = async () => await import("./components/ui_select");
  select().then(f => f.init('select'))
}

if (document.querySelector("#product-tabs")) {
  let tabs = async () => await import('./components/ui_tabs');
  tabs().then(t => t.init({
    elm: "#product-tabs",
    shouldScrollTabIntoView: false,
  }).init())
}



let addToCompare = null;
$(document).on('click', '.addtocompare', function(e) {
  e.preventDefault();
  e.stopPropagation();
  if (addToCompare === null) {
    let addCompare = async () => await import('./components/Compare/AddToCompare');
    addCompare().then(f => addToCompare = f.add).then(() => addToCompare(this))
  } else {
    addToCompare(this);
  }
})

require("./components/Compare/compare")


let d = new Date();
let body = $('body');
let time = body.data('time');
let loc = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds());
let time_zone = ((time - loc / 1000) / 3600).toFixed(0);
body.data('time_zone', time_zone);

$('input[name="user_data_time_zone"]').val(time_zone);

Swiper.use([Navigation, Autoplay, Thumbs]);

const swiper_product_thumbs = document.querySelector('.swiper-product-thumbs');

const swiper_product_options = {
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-product-next',
    prevEl: '.swiper-product-prev',
  }
}

if (swiper_product_thumbs) {
  const swiperProductThumbs = new Swiper(swiper_product_thumbs, {
    spaceBetween: 5,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      540: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 4,
      },
      1385: {
        slidesPerView: 5,
      }
    }
  });
  swiper_product_options.thumbs = {
    swiper: swiperProductThumbs
  }
}

new Swiper('.swiper-product', swiper_product_options);

const swiperSpecificationsThumbs = new Swiper('.swiper-specifications-thumbs', {
  spaceBetween: 10,
  slidesPerView: 2,
  breakpoints: {
    540: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
    1385: {
      slidesPerView: 4,
    }
  }
});

new Swiper('.swiper-specifications', {
  spaceBetween: 10,
  thumbs: {
    swiper: swiperSpecificationsThumbs
  }
});

(function spoiler() {
  let spoiler = $(".spoiler");
  if (spoiler.length) {
    $('.spoiler-btn').on('click', function() {
      $(this).closest(".spoiler").find(".spoiler-items").slideToggle(function() {
        $(this).closest(".spoiler").toggleClass("collapsed");
      });
    });
  }
})();

const anchors = document.querySelectorAll('.main-article-aside-navigation')
for (let anchor of anchors) {
  anchor.addEventListener('click', function(e) {
    e.preventDefault()
    const blockID = anchor.getAttribute('href').substr(anchor.getAttribute('href').indexOf('#') + 1);
    document.getElementById(blockID).scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  })
}

$(document).on('change', 'select[name="heat_region"]', function(e) {
  (async () => {
    try {
      let params = new URLSearchParams({
        'get': 'getsity',
        'id': e.currentTarget.value
      });
      let response = await Agent.post('/includes/php/class/modules/heat_losses_buildings.php', params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      });
      const content = await response.json();
      let str = '';
      content.forEach(function(item) {
        str += `<option value = "${item['id']}">${item['name'].trim()}</option>`;
      })
      $('#city').html(str).niceSelect('update');
    } catch (e) {
      console.log(e);
    }
  })();
});

$('.js_clear_heat').click(function(e) {
  e.preventDefault();
  $('.js_heat_result_block').hide();
  $('.js_empty_heat').show();
  $('.rbm_js_filter_result').html('');
  $(".v_footer").val('');
  $("#V").val('');
  $("[name='is_footer'] option, #type_of_fuel option").prop('selected', false).eq(0).prop('selected', true);
  $("#region option, #construction option").prop('selected', false).eq(0).prop('selected', true);
  $("#region, #construction, #region, #construction, [name='is_footer']").trigger('change').niceSelect('update');
});

$('#btn-heat').on('click', function(e) {
  e.preventDefault();
  let $this = $(this);
  let data = {
    'get': 'result',
    'region': $("#region").val(),
    'city': $("#city").val(),
    'v': $("#V").val(),
    'type_of_fuel': $("#type_of_fuel").val(),
    'construction': $("#construction").val(),
	'type': $this.data('id') || 1
  };

  if ($("[name='is_footer']").val() === 'r1') {
    data.building_basement = $(".v_footer").val();
  }

  (async () => {
    try {
      $this.closest('section').addClass('preloader');

      let response = await fetch('/includes/php/class/modules/heat_losses_buildings.php', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          //'Content-Type': 'application/json'
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(data)
      })

      const content = await response.json();

      if (content.success) {
        if (content.data) {
          $('.rbm_js_filter_result').html(content.message + content.data);
		  events.dispatch('filter.search');
        } else {
          $('.rbm_js_filter_result').html(content.message);
        }
        $('.js_heat_result_block').show();
        $('.js_empty_heat').hide();
      } else {
        throw new Error(content.message)
      }
    } catch (e) {
      const notice = async () => await import("./components/messages");
      notice().then(n => n.notice(e.message, true))

      $('.js_heat_result_block').hide();
      $('.js_empty_heat').show();
      $('.rbm_js_filter_result').html('');
    } finally {
      $this.closest('section').removeClass('preloader');
    }
  })();
});

$(document).on('click', '.rbm_js_tabs_btn_a', function() {
  var number = $(this).data('number');
  $('.rbm_js_tabs_btn_a').removeClass('active');
  $('.rbm_js_tabs_a').hide();
  $('.rbm_js_tabs_a_' + number).show();
  $('.rbm_js_tabs_btn_a_' + number).addClass('active');
})

$(document).on('click', '.rbm_js_tabs_btn', function() {
  var number = $(this).data('number');
  $('.rbm_js_tabs_btn').removeClass('active');
  $('.rbm_js_tabs').hide();
  $('.rbm_js_tabs_' + number).show();
  $('.rbm_js_tabs_btn_' + number).addClass('active');
})

$(document).on('click', '.scroll_up_tab', function(e) {
  $("html, body").animate({
    "scrollTop": $('.rbm_js_tabs_header').offset().top - (20 + $('.main-header-top').height())
  }, "slow");
  return false;
});

var iAnchor = 0;
var menuAnchor = '';
$('.js_title_article_text h2, h3').not('.no_menu').each(function(i, elem) {
  iAnchor++;
  menuAnchor += "<span class='scroll_to_tab hover-text-primary main-article-aside-navigation' data-name='anchor-" + iAnchor + "' title='Перейти к " + elem.innerHTML + "'>" +
    elem.innerHTML + "</span>";
  $(elem).addClass('anchor-' + iAnchor);
});

$('.js_anchor_div').append(menuAnchor);

$(document).on('click', '.scroll_to_tab', function(e) {
	var thisAncore = $(this).data('name');
	let block = document.querySelector(`.${thisAncore}`);
	if(block){
		$("html, body").animate({
			"scrollTop": $(block).offset().top - (60)
		}, "slow");
		
		if(block.classList.contains('product-tabs__tab') && !block.classList.contains('active')){
			block.click();
		}
	}
	
	return false;
});

let phoneFormat = null
$(document).on('keyup', 'input[type="tel"]', function(event) {
  if (phoneFormat === null) {
    let phoneFormatter = async () => await import('./components/phone');
    phoneFormatter().then(e => phoneFormat = e.format).then(() => phoneFormat($(event.currentTarget), event));
  } else {
    phoneFormat($(event.currentTarget), event)
  }
});

function dropdawn() {
  $('.dropdawn-btn').on("mouseenter mouseleave", function() {
    $(this).closest('.dropdawn').find('.dropdawn-menu').addClass('active');
    $(this).addClass('active');
  })
  $('.dropdawn').on("mouseleave", function() {
    $(this).find('.dropdawn-menu').removeClass('active');
    $(this).find('.dropdawn-btn').removeClass('active');
  });
}

dropdawn();

function mobile_menu() {
  let btn = document.querySelector('.main-header-top-mobileBtn');
  let menu = document.querySelector('.mobile-menu');
  let body = document.querySelector('body');
  let submenu = menu.querySelector('.submenu');
  if (!menu.classList.contains('open')) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      menu.classList.toggle('open');
      body.classList.toggle('menu-open');
    })
  }
  document.addEventListener('click', function(e) {
    if (menu.classList.contains('open')) {
      if (e.target == menu || !menu.contains(e.target)) {
        menu.classList.toggle('open');
        body.classList.toggle('menu-open');
      }
      if (submenu.classList.contains('open')) {
        menu.classList.remove('submenu-open');
        submenu.classList.remove('open');
      }
    }
  })
  submenu.querySelector('.submenu-btn').addEventListener('click', function(e) {
    e.stopPropagation();
    menu.classList.toggle('submenu-open');
    submenu.classList.toggle('open');
  })
}
mobile_menu();

if (document.querySelector('.instagram')) {
  const insta = async () => await import('./components/instagram');
  insta().then(e => e.showInstagram());
}

$('[data-youtube]').fancybox({
  media: {
    youtube: {
      params: {
        autoplay: 1
      }
    }
  }
});

const Share = {
  vkontakte: function(purl, ptitle) {
    let url = 'http://vkontakte.ru/share.php?';
    url += 'url=' + encodeURIComponent(purl);
    url += '&title=' + encodeURIComponent(ptitle);
    url += '&noparse=true';
    Share.popup(url);
  },

  odnoklassniki: function(purl, ptitle) {
    let url1 = 'https://connect.ok.ru/offer';
    url1 += '?url=' + encodeURIComponent(purl);
    url1 += '&title=' + encodeURIComponent(ptitle);
    Share.popup(url1);
  },

  facebook: function(purl, ptitle) {
    let url2 = 'http://www.facebook.com/sharer.php?s=100';
    url2 += '&p[title]=' + encodeURIComponent(ptitle);
    url2 += '&p[url]=' + encodeURIComponent(purl);
    Share.popup(url2);
  },

  twitter: function(purl, ptitle) {
    let url3 = 'http://twitter.com/share?';
    url3 += 'text=' + encodeURIComponent(ptitle);
    url3 += '&url=' + encodeURIComponent(purl);
    Share.popup(url3);
  },

  mailru: function(purl, ptitle, pimg, text) {
    let url4 = 'http://connect.mail.ru/share?';
    url4 += 'url=' + encodeURIComponent(purl);
    url4 += '&title=' + encodeURIComponent(ptitle);
    Share.popup(url4)
  },

  popup: function(url) {
    window.open(url, '', 'toolbar=0,status=0,width=626,height=436');
  }
};

window.Share = Share;

document.querySelectorAll('.share-btn').forEach(item => {
  item.addEventListener('click', function() {
    item.closest('.share').classList.toggle('active');
  })
})

if (document.querySelector('.main-category-desc-gallery')) {
  function galleryAlign() {
    const block = document.querySelector('.main-category-desc-block');
    const photo = document.querySelector('.main-category-desc-gallery');
    let blockHeight = block.offsetHeight;
    let photoHeight = photo.offsetHeight;
    if (photoHeight > blockHeight) {
      photo.style.height = (blockHeight - 50) + "px";
    }
  }

  galleryAlign();
}

window.print_page = pageId => {
  // Agent.get(`/print_page.php?id=${pageId}`).then(e => e.text())
  //     .then(e => {
  //         CallPrint(e, 'left=50,top=50,width=720,height=560,toolbar=0,scrollbars=1,status=0');
  //     }).catch(e => console.log(e.message));

  let btn = document.querySelector('#print_page_button')
  btn.classList.add('preloader')
  let currentFrame = document.querySelector('#print_page_id');
  if (currentFrame) {
    currentFrame.parentNode.removeChild(currentFrame);
  }

  let ifrm = document.createElement("iframe");
  ifrm.setAttribute('id', `print_page_id`);
  ifrm.setAttribute('style', `display:none;`);
  ifrm.setAttribute('name', `print_page_id`);
  ifrm.setAttribute("src", `/print_page.php?id=${pageId}`);
  ifrm.style.width = "0px";
  ifrm.style.height = "0px";
  document.body.appendChild(ifrm);

  ifrm.onload = function() {
    btn.classList.remove('preloader')
    ifrm.focus();
    ifrm.contentWindow.print();

  }

}

const ratingSelectors = document.querySelectorAll(".rating, .rating-read");
if (ratingSelectors.length) {
  const rating = async () => await import("./components/rating");
  rating().then(e => e.rating(ratingSelectors))
}

let tooltipSelectors = document.querySelectorAll('.tooltip');
if (tooltipSelectors.length) {
  const tooltip = async () => await import("./components/tooltip");
  tooltip().then(e => e.tooltip(tooltipSelectors))
}

if (document.querySelectorAll('.swiper-certificates')) {
  let swiperCerfificates0 = new Swiper('.swiper-certificates-0', {
    spaceBetween: 30,
    slidesPerView: 2,
    watchSlidesVisibility: true,
    slideActiveClass: "active",
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
      1300: {
        slidesPerView: 4
      }
    }
  })
  let swiperCerfificates1 = new Swiper('.swiper-certificates-1', {
    spaceBetween: 30,
    slidesPerView: 2,
    watchSlidesVisibility: true,
    slideActiveClass: "active",
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
      1300: {
        slidesPerView: 4
      }
    }
  })
  let swiperCerfificates2 = new Swiper('.swiper-certificates-2', {
    spaceBetween: 30,
    slidesPerView: 2,
    watchSlidesVisibility: true,
    slideActiveClass: "active",
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
      1300: {
        slidesPerView: 4
      }
    }
  })
  let swiperCerfificates3 = new Swiper('.swiper-certificates-3', {
    spaceBetween: 30,
    slidesPerView: 2,
    watchSlidesVisibility: true,
    slideActiveClass: "active",
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
      1300: {
        slidesPerView: 4
      }
    }
  })
}
$('.rbm_js_tabs_hidden').hide();


$(document).on('input', '[name="search_dictionary"]', function(){
	let term = $(this).val().trim();

	if(term.length){
		$('.main-dictionary-filter-value-item a').each(function(){
			let s = this.innerHTML.toLowerCase().search(term);
			
			if(s === 0){
				$(this).parent().show();
			}else{
				$(this).parent().hide();
			}
		})
	}else{
		$('.main-dictionary-filter-value-item').show();
	}
});
function scrollTop() {
  $("button.up").on("click", function() {
    $("html, body").stop().animate({
      scrollTop: 0
    }, 2000, 'swing');
  })
}
scrollTop(); 